import React, { useState } from 'react'

interface ILocationVaultRightAction {
    onViewSwitch: (value: any) => void;
    isGridView: any;
    onEdit?: () => void;
    isScouting?: boolean;
    hideViewToggle?: boolean
}

const LocationVaultRightAction = (props: ILocationVaultRightAction) => {

    return (
        <div className="lv-view-controls">
            {!props?.hideViewToggle &&
                <div className="lv-view-btn-wrap">
                    <button
                        className={`lv-view-toggle-btn ${props.isGridView ? "active" : ""}`}
                        onClick={() => props.onViewSwitch(true)}
                    >
                        <img src={props.isGridView ? '/assets/images/grid-view-active.svg' : '/assets/images/grid-view.svg'} />
                    </button>

                    <button
                        className={`lv-view-toggle-btn ${!props.isGridView ? "active" : ""}`}
                        onClick={() => props.onViewSwitch(false)}
                    >
                        {props?.isScouting
                            ?
                            <img src={!props.isGridView ? '/assets/images/map-active.svg' : '/assets/images/map-inactive.svg'} />
                            :
                            <img src={!props.isGridView ? '/assets/images/list-view-active.svg' : '/assets/images/list-view.svg'} />
                        }
                    </button>
                </div>
            }
            {/* <button onClick={props?.onEdit} className="lv-view-btn">
                <img src='/assets/images/edit-pencil-icon.svg' />
            </button> */}
            <button className="lv-btn-filter">
                <img src='/assets/images/filter_icon.svg' />
                Filter
            </button>
        </div>
    )
}

export default LocationVaultRightAction